import React from 'react';
import { translate  } from 'react-i18next';
import { Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';
import {observer} from 'mobx-react';
import TextField from '../Components/Form/TextField';
import moment from 'moment-timezone';
import Voucher from '../Store/Voucher';


@observer
class VoucherSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checkingVoucher: false,
    };
  }


  applyVoucher = () => {
    this.setState({
      checkingVoucher: true
    });

    this.props.booking.applyDiscounts().then(() => {
      this.setState({
        invalidVoucher: !this.props.booking.voucher.id,
        checkingVoucher: false
      });
    });
  };

  removeVoucher = () => {
    this.props.booking.removeVoucher();
  };

  render() {
    const { t, booking } = this.props;

    return (
    	<div>
        <Row>
          <Col xs='12'>
            <TextField
              type='text'
              disabled={this.state.checkingVoucher || booking.voucher.id}
              name='voucher'
              error={this.state.invalidVoucher}
              errorText={t('Invalid voucher')}
              value={booking.voucher.code}
              onChange={(e) => booking.voucher.code = e.target.value}
              label={t('Voucher code')}
            />
          </Col>
          <Col xs='12' className='mb-4'>
            {
              !booking.voucher.id &&
              <Button
                block
                color='secondary'
                size='md'
                disabled={this.state.checkingVoucher || booking.voucher.code === ''}
                onClick={this.applyVoucher}
              >
                {this.state.checkingVoucher ? t('Checking voucher') : t('Apply voucher')}
              </Button> ||
              <Button
                block
                color='secondary'
                size='md'
                onClick={this.removeVoucher}
              >
                {t('Remove voucher')}
              </Button>
            }
          </Col>
        </Row>
      </div>
    );
  }
};

export default translate()(VoucherSection);



// WEBPACK FOOTER //
// ./src/App/Checkout/VoucherSection.js